var map = {
	"./example.svg": "42a5",
	"./eye-open.svg": "8468",
	"./eye.svg": "083f",
	"./form.svg": "bfb0",
	"./link.svg": "01df",
	"./nested.svg": "3ed9",
	"./password.svg": "5b56",
	"./table.svg": "75d5",
	"./tree.svg": "fc7e",
	"./user.svg": "4d66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";